import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { BRAND } from "../../data/mock";

export const AdminLogin = ({ onSubmit, loading }) => {
  const [input, setInput] = useState("");

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#050608] px-4" data-testid="admin-login-page">
      <form
        onSubmit={(e) => { e.preventDefault(); onSubmit(input.trim()); }}
        className="w-full max-w-sm rounded-3xl border border-white/10 bg-[#0b0d10] p-8"
      >
        <div className="flex items-center gap-2 font-heading text-lg text-white">
          <img src={BRAND.logoUrl} alt="logo" className="h-8 w-auto object-contain" />
          {BRAND.logoFirst}<span className="text-[#2f7fff]">{BRAND.logoAccent}</span>{BRAND.logoSecond}
        </div>
        <p className="mt-2 text-sm text-zinc-400">Enter your admin access code to view orders.</p>
        <div className="relative mt-6">
          <KeyRound className="absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-zinc-500" />
          <input
            type="password"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Access code"
            className="w-full rounded-full border border-white/15 bg-white/5 py-3 pl-11 pr-4 text-sm text-white placeholder:text-zinc-500 outline-none focus:border-[#2f7fff]"
            data-testid="admin-code-input"
          />
        </div>
        <button
          type="submit"
          disabled={loading || !input.trim()}
          className="mt-4 flex w-full items-center justify-center gap-2 rounded-full bg-[#2f7fff] hover:bg-[#4b91ff] disabled:opacity-60 py-3 font-semibold text-white transition-colors"
          data-testid="admin-login-button"
        >
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "View orders"}
        </button>
      </form>
    </div>
  );
};
